import { EditableImage } from "@/schema/smartupload.schema";
import { create } from "zustand";

export type RemovedImage = {
  image: EditableImage;
  productId: string;
  productName: string;
  variantId: string;
  variantName: string;
  originalIndex: number;
};

type SmartUploadStore = {
  removedImages: RemovedImage[];
  removeImage: (entry: RemovedImage) => void;
  restoreImage: (imageId: string) => RemovedImage | undefined;
  clearRemovedImages: () => void;
};

export const useSmartUploadStore = create<SmartUploadStore>((set, get) => ({
  removedImages: [],
  removeImage: (entry) =>
    set((s) => ({ removedImages: [...s.removedImages, entry] })),
  restoreImage: (imageId) => {
    const entry = get().removedImages.find((r) => r.image.id === imageId);
    if (!entry) return undefined;
    set((s) => ({
      removedImages: s.removedImages.filter((r) => r.image.id !== imageId),
    }));
    return entry;
  },
  clearRemovedImages: () => set({ removedImages: [] }),
}));
